module.exports = __webpack_public_path__ + "img/so.10e1fa04.svg";